import { useState } from 'preact/hooks';
import { joinNeighborhood } from '../../data/membership';
import { mapJoinError } from '../errors';

export function JoinNeighborhood(props: { token: string; onJoined?: () => void }) {
  const [firstName, setFirstName] = useState('');
  const [familyName, setFamilyName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [firstError, setFirstError] = useState<string | null>(null);
  const [familyError, setFamilyError] = useState<string | null>(null);

  async function doJoin() {
    setError(null);
    const f = firstName.trim();
    const fam = familyName.trim();
    setFirstError(!f ? 'Enter your first name' : null);
    setFamilyError(!fam ? 'Enter your family name' : null);
    if (!f || !fam) return;
    setBusy(true);
    try {
      await joinNeighborhood(props.token, fam, f);
      props.onJoined?.();
    } catch (e: any) {
      console.error('[join neighborhood]', e);
      setError(mapJoinError(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <section class="install-safe">
      <div class="install-card">
        <h2 class="install-title">Join your neighborhood</h2>
        <div class="install-body">
          <label class="form-label" for="first">Your first name</label>
          <input
            id="first"
            class="form-input"
            value={firstName}
            onInput={(e) => setFirstName((e.target as HTMLInputElement).value)}
            placeholder="First name"
            autocomplete="given-name"
          />
          {firstError && <div class="tiny-banner error" role="alert">{firstError}</div>}
          <label class="form-label" for="family">Family name</label>
          <input
            id="family"
            class="form-input"
            value={familyName}
            onInput={(e) => setFamilyName((e.target as HTMLInputElement).value)}
            placeholder="e.g. The Careys"
            autocomplete="organization"
          />
          <div class="install-actions" style="margin-top:12px;">
            <button
              class="primary-btn"
              type="button"
              disabled={busy || !firstName.trim() || !familyName.trim()}
              onClick={() => void doJoin()}
            >
              {busy ? 'Joining…' : 'Join'}
            </button>
          </div>
          {error && <div class="tiny-banner error" role="alert">{error}</div>}
          {familyError && <div class="tiny-banner error" role="alert">{familyError}</div>}
        </div>
      </div>
    </section>
  );
}

